<template>
  <cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config" :footer="footer">
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import {
  getCategory,
  add,
  del,
  update,
  getDetails,
  getSwitch
} from "@/api/storage/category";
import { getCountry } from "@/api/system/country";

import cTable from "@/base/common/index";
import {getTransportCode} from "@/api/public";
export default {
  name: "category",

  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getCategory,
        getDetails,
        del,
        add,
        update,
        getCountry,
        beforeHandleList(data) {
          return JSON.parse(JSON.stringify(data.data));
        },
        getSwitch
      },
      config: {
        height: 630,
        showOverflow: false
      },
      footer: {
        show: () => false
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              // console.log(data);
              // data.details = data.details.split(/[,|，]/g);
              // data.details2 = data.details2.split(/[,|，]/g);
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "name cannot be empty",
                  trigger: "blur"
                }
              ],
              name_en: [
                {
                  required: true,
                  message: "name En cannot be empty",
                  trigger: "blur"
                }
              ],
              to_country: [
                {
                  required: true,
                  message: "country cannot be empty",
                  trigger: "change"
                }
              ],
              transport_code: [
                {
                  required: true,
                  message: "运输渠道代码不能为空",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            { name: 24 },
            { name_en: 24 },
            { to_country: 24 },
            { transport_code: 24 },
            { sort: 24 },
            { details2: 24 },
            { details: 24 },
            { remarks: 24 }
          ],
          fields: [
            {
              name: () => this.$t("category_name"),
              key: "name",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("category_name");
              }
            },
            {
              name: () => this.$tz("英文名称"),
              key: "name_en",
              component: "Input",
              placeholder() {
                return this.$tz("请输入,英文名称");
              }
            },
            {
              name: () => this.$t("sort"),
              key: "sort",
              component: "InputNumber",
              placeholder() {
                return this.$t("the_smaller_value");
              },
              bind: {
                step: 1,
                min: 0,
                style: {
                  width: "100%"
                }
              },
              default: 99
            },
            {
              name: () => this.$t("countryName"),
              key: "to_country",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("countryName");
              },
              options: [],
              config: { label: "title", value: "code" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCountry")
                  ).payload.rows;
                  this.$forceUpdate();
                  field.options.unshift({ title: "ALL", code: "ALL" });
                }
              }
            },
            {
              name: () => '运输渠道',
              key: "transport_code",
              component: "Select",
              placeholder() {
                return '请选择运输渠道';
              },
              options: [],
              config: { label: "method_name", value: "method_code" },
              methods: {
                async list({ field }) {
                  getTransportCode().then(r => {
                    field.options = r.data.payload.rows;
                    this.$forceUpdate();
                    field.options.unshift({ method_name: "ALL", method_code: "ALL" });
                  })

                }
              }
            },
            {
              name: () => this.$t("charged_details"),
              key: "details2",
              component: "Input",
              placeholder() {
                return this.$t("multiple_details");
              },
              bind: {
                type: "textarea",
                rows: 4
              }
            },
            {
              name: () => this.$t("Not") + this.$t("charged_details"),
              key: "details",
              component: "Input",
              placeholder() {
                return this.$t("multiple_details");
              },
              bind: {
                type: "textarea",
                rows: 4
              }
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 3
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          // {
          //   key: "country_id",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("countryName");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "title", value: "id" },
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          // {
          //   key: "remote_regions",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("remote_regions");
          //   },
          //   clearable: true,
          //   options: [
          //     { label: this.$t('YES'), value: 1 },
          //     { label: this.$t('NO'), value: 0 }
          //   ],
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          // {
          //   key: "status",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("exlType");
          //   },
          //   clearable: true,
          //   options: [
          //     { label: this.$t('enable'), value: "ENABLE" },
          //     { label: this.$t('disable'), value: "DISABLE" }
          //   ],
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
              // autosize: { minRows: 2, maxRows: 2 }
            }
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              }
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60
        },
        {
          name: () => this.$t("category_name"),
          key: "name",
          width: 100,
          align: "left"
        },
        {
          name: () => '运输模式',
          key: "transport_name",
          width: 140,
          align: "center"
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
          width: 80
        },
        {
          name: () => this.$t("charged_details"),
          key: "details2",
          align: "left",
          render: (h, { row }) => {
            if (row.details2 != "") {
              let data = row.details2.split(/[,|，]/g);
              return h("div", [
                data.map((item, index) => {
                  return h(
                    "Button",
                    {
                      props: {
                        type: index % 2 == 0 ? "info" : "success",
                        size: "small"
                      },
                      style: {
                        marginRight: "5px",
                        marginBottom: "5px",
                        float: "left"
                      }
                    },
                    item
                  );
                })
              ]);
            }
          }
        },
        {
          name: () => this.$t("Non Battery"),
          key: "details",
          align: "left",
          render: (h, { row }) => {
            if (row.details != "") {
              let data = row.details.split(/[,|，]/g);
              return h("div", [
                data.map((item, index) => {
                  return h(
                    "Button",
                    {
                      props: {
                        type: index % 2 == 0 ? "info" : "success",
                        size: "small"
                      },
                      style: {
                        marginRight: "5px",
                        marginBottom: "5px"
                      }
                    },
                    item
                  );
                })
              ]);
            }
          }
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          width: 100,
          align: "left"
        },
        {
          name: () => this.$t("tip"),
          key: "status_txt",
          width: 100
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          width: 100
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 160
          // methods: {
          //   render({ value }) {
          //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
          //   }
          // }
        },
        {
          name: () => this.$t("upTime"),
          key: "update_time",
          width: 160
          // methods: {
          //   render({ value }) {
          //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
          //   }
          // }
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              }
            },
            {
              name: () => this.$t("enable"),
              type: "enable",
              fnName: "switchBtn",
              bind: {
                type: "primary"
              },
              show: ({ row }) => {
                return row.status == "DISABLE";
              }
            },
            {
              name: () => this.$t("disable"),
              type: "disable",
              fnName: "switchBtn",
              bind: {
                type: "error"
              },
              show: ({ row }) => {
                return row.status == "ENABLE";
              }
            }
            // {
            //   name: this.$t("delete"),
            //   type: "delete",
            //   fnName: "delete"
            //   // bind: {
            //   //   type: "error"
            //   // }
            // }
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                // let data = JSON.parse(JSON.stringify(res.payload));
                // data.details = data.details.join(",");
                // data.details2 = data.details2.join(",");
                this.getModal("add").open(res.payload);
              });
            },
            // delete({ row }) {
            //   this.$Modal.confirm({
            //     title: this.$t("delete"),
            //     width: 300,
            //     content: this.$t("titleModal"),
            //     onOk: () => {
            //       this.handleRequestMethods("del", row.id).then(res => {
            //         this.$Message["success"]({
            //           background: true,
            //           content: res.msg
            //         });
            //         this.getList();
            //       });
            //     }
            //   });
            // },
            switchBtn({ row }) {
              this.$Modal.confirm({
                title:
                  row.status == "ENABLE"
                    ? this.$t("disable")
                    : this.$t("enable"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("getSwitch", row.id, true).then(
                    res => {
                      this.getList();
                    }
                  );
                }
              });
            }
          }
        }
      ]
    };
  }
  // mounted() {
  //   this.header.searchs.forEach(async item => {
  //     if (item.key === "country_id")
  //       item.options = (await getCountry()).data.payload.rows;
  //   });
  // }
};
</script>
